import { render } from "./CreateVote.vue?vue&type=template&id=7b0d869e&scoped=true"
import script from "./CreateVote.vue?vue&type=script&lang=js"
export * from "./CreateVote.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=7b0d869e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0d869e"]])

export default __exports__